import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { useGetCity } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveCity } from '../../shared/components';

export type UpdateCityPageProps = {};

const UpdateCityPage: React.FC<UpdateCityPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_ciudad);

  const { id } = useParams();

  const { data, isLoading } = useGetCity(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_ciudad) return <Navigate to="/configuracion/paises" />;

  return <SaveCity titlePage="Editar Ciudad" editCity={data.data} />;
};

export default UpdateCityPage;
